import { useEffect, useState } from 'preact/hooks';

let pushFn: ((msg: string, kind?: 'info' | 'error') => void) | null = null;

/**
 * Pushes a transient toast message to the global host.
 */
export function toast(message: string, kind: 'info' | 'error' = 'info'): void {
  if (pushFn) {
    pushFn(message, kind);
  }
}

interface ToastState {
  message: string;
  kind: 'info' | 'error';
  visible: boolean;
}

/**
 * Renders a single toast container; mount once at the root of the app.
 */
export function ToastHost() {
  const [state, setState] = useState<ToastState>({ message: '', kind: 'info', visible: false });

  useEffect(() => {
    pushFn = (message, kind = 'info') => {
      setState({ message, kind, visible: true });
      window.setTimeout(() => {
        setState((s) => ({ ...s, visible: false }));
      }, 1800);
    };
    return () => { pushFn = null; };
  }, []);

  const cls = `toast ${state.visible ? 'show ' : ''}${state.kind === 'error' ? 'error' : ''}`.trim();
  return <div class={cls}>{state.message}</div>;
}
